import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  IconButton,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import MalayalamKeyboard from "../components/MalayalamKeyboard";
import PlaceAnswer from "../components/PlaceAnswer";
import PlayPuzzle from "../components/PlayPuzzle";
import Header from "../components/Header";
import { API_URL, FRONTEND_URL } from "../components/Constant";
import axios from "axios";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import EditIcon from "@mui/icons-material/Edit";
import Colors from "../components/Colors";

const CrosswordCreator = () => {
  const [tabIndex, setTabIndex] = useState(0); // Default value of tabIndex
  const [clickedQuestion, setClickedQuestion] = useState([]);
  const [isDelete, setIsDelete] = useState(false);

  const handleDeleteClick = () => {
    setIsDelete(true);
  };

  const handleCloseisDeletePopUp = () => {
    setIsDelete(false);
  };

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
    localStorage.setItem("tabIndex", newValue); // Save the current tabIndex to localStorage
  };

  useEffect(() => {
    const referrer = document.referrer; // Get the referrer URL
    const targetReferrer = `${FRONTEND_URL}/game_name`;
    console.log("referrer", referrer);
    console.log("targetReferrer", targetReferrer);
    if (referrer === targetReferrer) {
      setTabIndex(0); // Set tabIndex to 0 if the referrer matches
    } else {
      const savedTabIndex = localStorage.getItem("tabIndex");
      if (savedTabIndex !== null) {
        setTabIndex(parseInt(savedTabIndex, 10)); // Restore saved tabIndex
      }
    }
  }, []);

  const handleDelete = async () => {
    try {
      const response = await axios.post(`${API_URL}/delete_game`, {
        gameId: localStorage.getItem("gameId"),
        CreatorTocken: localStorage.getItem("CreatorTocken"),
      });
      console.log("response.data", response.data);

      if (response.data.success === true) {
        setIsDelete(false);
        localStorage.removeItem("gameId");
        window.location.href = "/creator-landing";
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        width: "100%",
        alignItems: "center",
        height: "100%",
        minHeight: "100vh",
        backgroundColor: Colors.bgColor,
      }}
    >
      <Header></Header>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          justifyContent: "center",
          width: "100%",
          alignItems: "center",
          height: "100%",
          maxWidth: "94%",
          marginBottom: "36px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "16px",
            flexDirection: "row",
            width: "100%",
            marginTop: "16px",
          }}
        >
          {/* <Box onClick={() => {
  localStorage.setItem('IsEdit', true);
  window.location.href = "/game_name";
}}

        sx={{
          background: Colors.button2,
          color: "#fff",
          width: "150px",
          padding: "8px 12px",
          border: "1px solid ",
          borderColor:Colors.button2,
          borderRadius: "8px",
          cursor: "pointer",
          fontSize: "14px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          transition: "background 0.3s, transform 0.3s",
          "&:hover": {
            background: Colors.button2,
            transform: "scale(1.05)",
          },
          "&:active": {
            background:Colors.button2,
          },
        }}
      >
        {localStorage.getItem("Gamemode")}
        <IconButton
         onClick={() => {
          localStorage.setItem('IsEdit', true);
          window.location.href = "/game_name";
        }}
        
          sx={{ color: "#fff", padding: 0 }}
        >
          <EditIcon fontSize="small" />
        </IconButton>
      </Box> */}

          <Box
            onClick={() => {
              localStorage.setItem("IsEdit", true);
              window.location.href = "/theme";
            }}
            sx={{
              background: Colors.button1,
              color: "#fff",
              width: "150px",
              padding: "8px 12px",
              border: "1px solid",
              borderColor: Colors.button1,
              borderRadius: "8px",
              cursor: "pointer",
              fontSize: "14px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              transition: "background 0.3s, transform 0.3s",
              "&:hover": {
                background: Colors.button1,
                transform: "scale(1.05)",
              },
              "&:active": {
                background: Colors.button1,
              },
            }}
          >
            {localStorage.getItem("theme")}

            <IconButton
              onClick={() => {
                localStorage.setItem("IsEdit", true);
                window.location.href = "/theme";
              }}
              sx={{ color: "#fff", padding: 0 }}
            >
              <EditIcon fontSize="small" />
            </IconButton>
          </Box>

          <Box
            onClick={() => {
              localStorage.setItem("IsEdit", true);
              localStorage.setItem(
                "OldGameName",
                localStorage.getItem("gameId"),
              );
              window.location.href = "/game_name";
            }}
            sx={{
              background: Colors.button2,
              color: "#fff",
              width: "150px",
              padding: "8px 12px",
              border: "1px solid ",
              borderColor: Colors.button2,
              borderRadius: "8px",
              cursor: "pointer",
              fontSize: "14px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              transition: "background 0.3s, transform 0.3s",
              "&:hover": {
                background: Colors.button2,
                transform: "scale(1.05)",
              },
              "&:active": {
                background: Colors.button2,
              },
            }}
          >
            {localStorage.getItem("gameId")}
            <IconButton
              onClick={() => {
                localStorage.setItem("IsEdit", true);
                localStorage.setItem(
                  "OldGameName",
                  localStorage.getItem("gameId"),
                );
                window.location.href = "/game_name";
              }}
              sx={{ color: "#fff", padding: 0 }}
            >
              <EditIcon fontSize="small" />
            </IconButton>
          </Box>

          {/* Second Box with Edit Icon */}
          <Box
            onClick={() => {
              localStorage.setItem("IsEdit", true);
              localStorage.setItem(
                "OldGameName",
                localStorage.getItem("gameId"),
              );
              window.location.href = "/game_name";
            }}
            sx={{
              background: Colors.button1,
              color: "#fff",
              width: "150px",
              padding: "8px 12px",
              border: "1px solid ",
              borderColor: Colors.button1,
              borderRadius: "8px",
              cursor: "pointer",
              fontSize: "14px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              transition: "background 0.3s, transform 0.3s",
              "&:hover": {
                background: Colors.button1,
                transform: "scale(1.05)",
              },
              "&:active": {
                background: Colors.button1,
              },
            }}
          >
            {localStorage.getItem("category")}
            <IconButton
              onClick={() => {
                localStorage.setItem("IsEdit", true);
                localStorage.setItem(
                  "OldGameName",
                  localStorage.getItem("gameId"),
                );
                window.location.href = "/game_name";
              }}
              sx={{ color: "#fff", padding: 0 }}
            >
              <EditIcon fontSize="small" />
            </IconButton>
          </Box>
          {/* Second Box with Edit Icon */}

          <DeleteIcon
            onClick={handleDeleteClick}
            sx={{
              transition: "background 0.3s, transform 0.3s",
              cursor: "pointer",
              paddingTop: "6px",
              "&:hover": { transform: "scale(1.25)" },
            }}
          ></DeleteIcon>
        </Box>

        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          centered
          sx={{
            ".MuiTabs-indicator": {
              display: "none",
            },
            display: "flex",
            width: "100%",
            justifyContent: "center",
            gap: "16px",
          }}
        >
          <Tab
            label="Add Question"
            sx={{
              fontSize: "14px",
              color: Colors.tab1color,
              textDecoration: "none",
              textUnderlineOffset: "5px",
              "&:hover": {
                textDecoration: "underline",
                textUnderlineOffset: "5px",
                textDecorationThickness: "1.5px",
              },
              "&.Mui-selected": {
                color: Colors.tab1color,
                textDecoration: "underline",
                textUnderlineOffset: "5px",
                textDecorationThickness: "1.5px",
              },
            }}
          />
          <Tab
            label="Place Answer"
            sx={{
              fontSize: "14px",
              color: Colors.tab2color,
              textDecoration: "none",
              textUnderlineOffset: "5px",
              "&:hover": {
                textDecoration: "underline",
                textUnderlineOffset: "5px",
                textDecorationThickness: "1.5px",
              },
              "&.Mui-selected": {
                color: Colors.tab2color,
                textDecoration: "underline",
                textUnderlineOffset: "5px",
                textDecorationThickness: "1.5px",
              },
            }}
          />
          <Tab
            label="Play Puzzle"
            sx={{
              fontSize: "14px",
              color: Colors.tab1color,
              textDecoration: "none",
              textUnderlineOffset: "5px",
              "&:hover": {
                textDecoration: "underline",
                textUnderlineOffset: "5px",
                textDecorationThickness: "1.5px",
              },
              "&.Mui-selected": {
                color: Colors.tab1color,
                textDecoration: "underline",
                textUnderlineOffset: "5px",
                textDecorationThickness: "1.5px",
              },
            }}
          />
        </Tabs>

        {tabIndex === 0 && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
          >
            <MalayalamKeyboard
              clickedQuestion={clickedQuestion}
            ></MalayalamKeyboard>
          </Box>
        )}
        {tabIndex === 1 && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
          >
            <PlaceAnswer
              setClickedQuestion={setClickedQuestion}
              setTabIndex={setTabIndex}
            />
          </Box>
        )}
        {tabIndex === 2 && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
          >
            <PlayPuzzle />
          </Box>
        )}
      </Box>

      {isDelete && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: "5",
          }}
        >
          <Box
            sx={{
              width: "100%",
              height: "100%",
              gap: "5px",
              justifyContent: "center",
              alignItems: "center",
              position: "fixed",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                width: { md: "25%", sm: "25%", xs: "85%" },
                height: "36px",
                justifyContent: "right",
                alignItems: "right",
                display: "flex",
              }}
            >
              <IconButton
                onClick={handleCloseisDeletePopUp}
                sx={{
                  position: "fixed",
                  width: "36px",
                  height: "36px",
                }}
              >
                <CloseOutlinedIcon
                  sx={{
                    width: "36px",
                    height: "36px",
                    color: "#F9F9F9",
                    "&:hover": {
                      width: "40px",
                      height: "40px",
                      color: "#F9F9F9",
                      backgroundColor: "none",
                      background: "none",
                    },
                  }}
                ></CloseOutlinedIcon>
              </IconButton>
            </Box>
            <Box
              sx={{
                width: { md: "25%", sm: "25%", xs: "85%" },
                height: "fit-content",
                backgroundColor: "#FFF",
                border: "1px solid",
                borderColor: "#FFF",
                borderRadius: "4px ",
                boxShadow: "none",
                boxSizing: "border-box",
                zIndex: "3",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  gap: "16px",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    gap: "16px",
                    paddingTop: "13%",
                    justifyContent: "center",
                    alignContent: "center",
                    height: "86%",
                    maxWidth: "75%",
                    paddingBottom: "13%",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                      gap: "20px",
                      justifyContent: "center",
                      alignContent: "center",
                      height: "100%",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "18px",
                        color: Colors.Tidesfont,
                        fontWeight: 600,
                      }}
                    >
                      Delete Game
                    </Typography>

                    <Typography sx={{ textAlign: "center", color: "#000" }}>
                      Are you sure you want to delete this game?
                    </Typography>
                    <Box
                      sx={{
                        width: "100%",
                        flexDirection: "row",
                        justifyContent: "center",
                        display: "flex",
                        alignItems: "center",
                        gap: { xs: "8px", md: "16px" },
                      }}
                    >
                      <Button
                        onClick={handleCloseisDeletePopUp}
                        sx={{
                          background: Colors.button1,
                          color: "#fff",
                          width: "120px",
                          border: "1px solid ",
                          borderColor: Colors.button1,
                          borderRadius: "8px",
                          cursor: "pointer",
                          fontSize: "12px",
                          transition: "background 0.3s, transform 0.3s",
                          "&:hover": {
                            background: Colors.button1,
                            transform: "scale(1.05)",
                          },
                          "&:active": {
                            background: Colors.button1,
                          },
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        onClick={handleDelete}
                        sx={{
                          background: Colors.button2,
                          color: "#fff",
                          width: "120px",
                          border: "1px solid",
                          borderColor: Colors.button2,
                          borderRadius: "8px",
                          cursor: "pointer",
                          fontSize: "12px",
                          transition: "background 0.3s, transform 0.3s",
                          "&:hover": {
                            background: Colors.button2,
                            transform: "scale(1.05)",
                          },
                          "&:active": {
                            background: Colors.button2,
                          },
                        }}
                      >
                        delete
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default CrosswordCreator;
